import { GlobalAxios } from "./../axios/axios-config";
import {
  INewIntegrationRule,
  IIntegrationRule,
} from "../models/integration-rule";

const INTEGRATION_RULE_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRule/";

export const createIntegrationRule = (item: INewIntegrationRule) => {
  return GlobalAxios.post(INTEGRATION_RULE_ROUTE, item);
};

export const getIntegrationRuleById = (id: string) => {
  return GlobalAxios.get<IIntegrationRule>(INTEGRATION_RULE_ROUTE + id);
};

export const updateIntegrationRuleById = ({
  item,
  id,
}: {
  item: INewIntegrationRule;
  id: string;
}) => {
  return GlobalAxios.put(INTEGRATION_RULE_ROUTE + id, item);
};
